
    <template>
    <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.01" width="16" height="16" fill="black"/>
    <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M2.73281 7.5H6.76719C7.17188 7.5 7.5 7.17188 7.5 6.76719V2.73281C7.5 2.32813 7.17188 2 6.76719 2H2.73281C2.32813 2 2 2.32813 2 2.73281V6.76719C2 7.17188 2.32813 7.5 2.73281 7.5ZM2.73281 14H6.76719C7.17188 14 7.5 13.6719 7.5 13.2672V9.23281C7.5 8.82812 7.17188 8.5 6.76719 8.5H2.73281C2.32813 8.5 2 8.82812 2 9.23281V13.2672C2 13.6719 2.32813 14 2.73281 14ZM13.2672 7.5H9.23281C8.82812 7.5 8.5 7.17188 8.5 6.76719V2.73281C8.5 2.32813 8.82812 2 9.23281 2H13.2672C13.6719 2 14 2.32813 14 2.73281V6.76719C14 7.17188 13.6719 7.5 13.2672 7.5ZM9.23281 14H13.2672C13.6719 14 14 13.6719 14 13.2672V9.23281C14 8.82812 13.6719 8.5 13.2672 8.5H9.23281C8.82812 8.5 8.5 8.82812 8.5 9.23281V13.2672C8.5 13.6719 8.82812 14 9.23281 14Z" 
        fill="currentColor"
    />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'DoubleList',
    }) as DefineComponent
    </script>
    